import * as React from 'react';

/**
 * Copy-to-clipboard with transient "copied" feedback. Track which value was
 * copied via a key, so a component can show feedback per field.
 */
export default function useCopy(resetMs = 1500) {
  const [copiedKey, setCopiedKey] = React.useState<string | null>(null);
  const timer = React.useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  React.useEffect(() => () => clearTimeout(timer.current), []);

  const copy = React.useCallback(
    (key: string, value: string) => {
      navigator.clipboard?.writeText(value);
      setCopiedKey(key);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopiedKey(null), resetMs);
    },
    [resetMs]
  );

  return { copiedKey, copy };
}
